export default __webpack_public_path__ + "static/media/mongodb.41634622.png";